/*
  Good-Natured Liefertag (13.10.2026)

  "Am Mittwoch bei dir Zuhause": Bestelltag + 4 Werktage.
  - Werktage = Montag bis Freitag, ohne bundesweite Feiertage.
  - Gerechnet wird in deutscher Zeit (Europe/Berlin), egal wo der Besucher sitzt.
  - Liegt der Tag eine Woche oder weiter weg (Feiertage), kommt das Datum dazu.

  Was das Skript tut:
  1) Jeden Platz [data-gn-liefertag] mit dem Wochentag fuellen
     (Liquid hat schon einen Wert ohne Feiertage hingeschrieben).
  2) Den Platzhalter [Liefertag] in Texten ersetzen, z. B. im Versandfenster
     ("Im Schnitt ist deine Bestellung am [Liefertag] bei dir."). Auf Seiten
     ohne Liefertag (window.gnLieferAus) faellt der ganze Satz weg.
  3) Im Warenkorb unter "Lieferzeit" den Schnitt ergaenzen - nicht, wenn
     etwas Vorbestelltes oder aus Selah/ZMF/FCGGS im Warenkorb liegt
     (window.gnLieferWkAus).
*/
(function () {
  'use strict';
  if (window.gnLiefertagJS) return;
  window.gnLiefertagJS = true;

  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var NAMEN = EN
    ? ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    : ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var TAG = 864e5;
  var TOKEN = '[Liefertag]';

  function heuteBerlin() {
    try {
      var s = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      var a = s.split('-');
      return Date.UTC(+a[0], +a[1] - 1, +a[2]);
    } catch (e) {
      var d = new Date();
      return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    }
  }

  function ostersonntag(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(j, monat - 1, tag);
  }

  var feiertagCache = {};
  function feiertage(j) {
    if (feiertagCache[j]) return feiertagCache[j];
    var o = ostersonntag(j);
    var liste = [
      Date.UTC(j, 0, 1), o - 2 * TAG, o + TAG, Date.UTC(j, 4, 1), o + 39 * TAG,
      o + 50 * TAG, Date.UTC(j, 9, 3), Date.UTC(j, 11, 25), Date.UTC(j, 11, 26)
    ];
    var set = {};
    liste.forEach(function (t) { set[t] = true; });
    return (feiertagCache[j] = set);
  }

  function berechnen() {
    var start = heuteBerlin();
    var t = start, n = 0, guard = 0;
    while (n < 4 && guard++ < 40) {
      t += TAG;
      var d = new Date(t);
      var wd = d.getUTCDay();
      if (wd === 0 || wd === 6) continue;
      if (feiertage(d.getUTCFullYear())[t]) continue;
      n++;
    }
    var ziel = new Date(t);
    var name = NAMEN[ziel.getUTCDay()];
    if ((t - start) / TAG >= 7) {
      var dd = ('0' + ziel.getUTCDate()).slice(-2), mm = ('0' + (ziel.getUTCMonth() + 1)).slice(-2);
      name += EN ? ' ' + dd + '/' + mm : ', ' + dd + '.' + mm + '.';
    }
    return name;
  }

  var NAME = berechnen();
  window.gnLiefertag = NAME;

  function plaetze(wurzel) {
    Array.prototype.forEach.call(wurzel.querySelectorAll('[data-gn-liefertag]'), function (el) {
      if (el.textContent !== NAME) el.textContent = NAME;
    });
  }

  function platzhalter(wurzel) {
    var gang = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var treffer = [];
    var k;
    while ((k = gang.nextNode())) {
      if (k.nodeValue && k.nodeValue.indexOf(TOKEN) > -1) treffer.push(k);
    }
    treffer.forEach(function (k) {
      if (window.gnLieferAus) {
        k.nodeValue = k.nodeValue.replace(/[^.!?]*\[Liefertag\][^.!?]*[.!?]?\s*/g, '');
      } else {
        k.nodeValue = k.nodeValue.split(TOKEN).join(NAME);
      }
    });
  }

  function warenkorb(wurzel) {
    if (window.gnLieferAus || window.gnLieferWkAus) return;
    Array.prototype.forEach.call(wurzel.querySelectorAll('.gn-wk-info dt'), function (dt) {
      if (!/Lieferzeit|Delivery/i.test(dt.textContent)) return;
      var dd = dt.nextElementSibling;
      if (!dd || dd.tagName !== 'DD' || dd.getAttribute('data-gn-lt')) return;
      dd.setAttribute('data-gn-lt', '1');
      var zeile = document.createElement('span');
      zeile.className = 'gn-lt-schnitt';
      zeile.style.display = 'block';
      zeile.innerHTML = EN
        ? 'Usually with you on <span data-gn-liefertag>' + NAME + '</span>'
        : 'Im Schnitt am <span data-gn-liefertag>' + NAME + '</span> bei dir';
      dd.appendChild(zeile);
    });
  }

  function alles(wurzel) {
    wurzel = wurzel || document.body;
    if (!wurzel) return;
    plaetze(wurzel);
    platzhalter(wurzel);
    warenkorb(wurzel);
  }

  function start() {
    alles(document.body);
    if (!('MutationObserver' in window)) return;
    var offen = false;
    new MutationObserver(function () {
      if (offen) return;
      offen = true;
      setTimeout(function () {
        offen = false;
        alles(document.body);
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();